<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    this.mainTab();
  },
  computed: {
    refresh() {
      return this.$store.getters.getRefresh;
    },
    canBankStatement() {
      return this.$permission("63");
    },
    canBankStatementByUser() {
      return this.$permission("64");
    },
    canDeposit() {
      return this.$permission("7");
    },
    canWithdraw() {
      return this.$permission("5");
    },
  },
  watch: {
    refresh(val) {
      val && this.$route();
      val && this.mounted();
      this.$store.commit("setRefresh", false);
    },
    $route(val) {
      if (val.name == "CollaboratorBankOnline") {
        this.mainTab();
      }
    },
  },
  methods: {
    mainTab() {
      let name = "";

      if (this.canBankStatement) {
        name = "CollaboratorAccountabilityOnlineBankStatement";
      } else if (this.canBankStatementByUser) {
        name = "CollaboratorBankStatementByUser";
      } else if (this.canDeposit) {
        name = "CollaboratorAccountabilityOnlineDeposits";
      } else if (this.canWithdraw) {
        name = "CollaboratorListWithdraws";
      }

      this.$router.push({
        name,
      });
    },
  },
};
</script>
